// TRAVESSIA E CADERNO, UM LUGAR SÓ (refino de 31/10/2026). As duas metades do
// mesmo diálogo: na Travessia o Mentor fala (comentários, insights, desafios,
// que se abrem com a página); no Caderno a pessoa responde e anota. Antes eram
// duas telas soltas, cada uma com a sua porta; agora são duas faces do livro,
// com a mesma chave no topo — trocar de face SUBSTITUI a tela (não empilha),
// e o voltar sai do livro, de onde a pessoa veio.
import React from 'react';
import './nova.css';

export type FaceDoLivro = 'travessia' | 'caderno';

export const LivroAbas: React.FC<{
  ativa: FaceDoLivro;
  onTrocar: (f: FaceDoLivro) => void;
  /** Trechos do caminho que abriram e a pessoa ainda não viu. */
  novas?: number;
  /** Sobre a capa desfocada do caderno: vidro escuro em vez do fundo da tela. */
  sobreImagem?: boolean;
}> = ({ ativa, onTrocar, novas = 0, sobreImagem }) => (
  <div className={`nv-livro-abas ${sobreImagem ? 'vidro' : ''}`} role="tablist" aria-label="Travessia e caderno do livro" data-livro-abas={ativa}>
    <span className="nv-livro-abas-trilho" style={{ transform: ativa === 'caderno' ? 'translateX(100%)' : 'none' }} aria-hidden="true" />
    {(['travessia', 'caderno'] as FaceDoLivro[]).map((f) => (
      <button key={f} type="button" role="tab" aria-selected={ativa === f} onClick={() => ativa !== f && onTrocar(f)} data-face={f}>
        {f === 'travessia' ? 'Travessia' : 'Caderno'}
        {f === 'travessia' && novas > 0 && ativa !== 'travessia' && <i aria-label={`${novas} novas`}>{novas}</i>}
      </button>
    ))}
  </div>
);
